import React from 'react';
import Base from './Base';

export default class Login extends Base {
    constructor(props) {
        super(props);
        this.state = {
            mobile: '',
            password: '',
            loading: true
        };
        window.document.body.classList = "loginBg";
    }
    save() {
        if (this.isBlank(this.state.mobile)) {
            this.showErorrMessage('شماره موبایل را وارد نمایید');
            return;
        }
        if (this.isBlank(this.state.password)) {
            this.showErorrMessage('کلمه عبور را وارد نمایید');
            return;
        }
        this.httpPost("api/v1/login/do", {
            mobile: this.state.mobile,
            password: this.state.password
        })
        .then(data => {
            if (data.status === 1) {
                window.location.href = "/";
            }
            this.showErorrMessage(data.message);
        })
        .catch(err => {
            this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
        });
    }
    componentDidMount() {
        this.httpPost("api/v1/login/get")
        .then(data=>{
            if (data.logged == 1) window.location.href = "/";
            else {
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {
        return (
            <div className="FormBox">
                <div className="form-group title">ورود به سیستم</div>
                <div className="form-group">
                    <label className="control-label">شماره موبایل</label>
                    <input type="text" defaultValue={this.state.mobile} onChange={e => this.state.mobile = e.target.value} className="form-control" />
                </div>
                <div className="form-group">
                    <label className="control-label">کلمه عبور</label>
                    <input type="password" defaultValue={this.state.password} onChange={e => this.state.password = e.target.value} className="form-control" />
                </div>
                <div className="form-group" style={{ "text-align": "center" }}>
                    <button className="btn btn-primary" onClick={e => this.save(e)}><i className="fa fa-key"></i> ورود</button>
                </div>
            </div>
        );
    }
    render() {
        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return (
            <div>
                {this.state.lockScreen === 1 && this.lockScreen()}
                { this.getToastContainer() }
                {contents}
            </div>
        );
    }
}